import React from 'react';
import PageHeader from '../components/PageHeader/index.js';
import Contact from '../components/PageSections/contact.js';

const ContactPage = () => {
return (
	  <>
      <PageHeader name="Contact Us" link="contact-us" />
      <Contact />
      
    </>
);
};

export default ContactPage;
